/* angular:styles/component:css;1664a5ec3ccacec08c606b656292a254528e2416612e98ce8a34379312fe5f59;/src/src/app/shared/components/formly/formly-select/formly-select.ts */
:host {
  width: 100%;
}
ion-item.custom-select-item::part(inner) {
  padding-right: 0 !important;
}
.ion-modal-fullscreen {
  --width: 100%;
  --max-width: 100%;
}
ion-select {
  color: inherit !important;
}
ion-select::part(label) {
  white-space: pre-wrap !important;
  font-size: initial !important;
  flex: 1;
  min-width: 30%;
  max-width: 50%;
  margin-inline-end: 0 !important;
}
.custom-ion-alert {
  color: var(--ion-color-text) !important;
}
.custom-select-item {
  --inner-padding-end: 0;
  display: flex;
  align-items: center;
}
.custom-select-item ion-label {
  margin: 0;
  flex: 0 0 auto;
  min-width: 30%;
  max-width: 50%;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-item .select-value-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;
  min-width: 0;
}
.custom-select-item ion-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-item ion-icon {
  flex-shrink: 0;
}
/*# sourceMappingURL=formly-select.css.map */
